/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../../components/auth/auth-constants';
import {EmailTranslationResource} from '../../../components/api/resources/resource/email-translation.resource';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-email-translation-route-page',
  template: `
    <adn-email-translation-list-page
      *ngIf="list"
      [list]="list">
    </adn-email-translation-list-page>
  `
})
export class EmailTranslationRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(EmailTranslationResource) private readonly EmailTranslation: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasNetwork(PERMISSIONS.manageSystem.apiKey)
      && !this.LocalUserPermissions.hasDataNetworkPermission(PERMISSIONS.dataAdmin.apiKey)
      && !this.LocalUserPermissions.hasNetworkPermission(PERMISSIONS.politicalAdmin.apiKey, null, 'POLITICAL');

    this.adnListHelper.setUpList(this.list, this.EmailTranslation, readOnly, 'fullEmailTranslationList', {
      baseTable: 'emailTranslation'
    });
  }
}
